// Pure Server-Sent Events parser. No fetch, no DOM, no React.
// Buffers partial frames across `push()` calls and emits complete `SseEvent`s.
// Spec: https://html.spec.whatwg.org/multipage/server-sent-events.html
// See react-rewrite-plan.md section 11.3 api-sse.

import { parseFrame } from './parseFrame';
import type { SseEvent } from './types';

export interface SseParser {
  push(chunk: string): SseEvent[];
  // Returns any complete frames left in the buffer. A partial frame (one with
  // no terminating blank line) is intentionally dropped.
  flush(): SseEvent[];
}

export function createSseParser(): SseParser {
  let buffer = '';

  function drain(): SseEvent[] {
    const events: SseEvent[] = [];
    let idx = buffer.indexOf('\n\n');
    while (idx !== -1) {
      const frame = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      const event = parseFrame(frame);
      if (event !== null) {
        events.push(event);
      }
      idx = buffer.indexOf('\n\n');
    }
    return events;
  }

  return {
    push(chunk: string): SseEvent[] {
      // Normalize CRLF and lone CR to LF so we only look for one separator.
      buffer += chunk.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return drain();
    },
    flush(): SseEvent[] {
      const remaining = drain();
      buffer = '';
      return remaining;
    },
  };
}
